import { useBrowserLocation } from '@vueuse/core'

export function useOrderCalendar(order = ref({})) {
  const nuxtApp = useNuxtApp()
  const location = useBrowserLocation()
  const { nameTitle } = useOrderCalendarTitle(order)
  // const nameTitle = ref('test name')

  const startTime = nuxtApp.$dayjs(order.value.booking_time)
  const googleCalendarPayload = reactive({
    summary: computed(() =>
      order.value.is_cust_num
        ? nuxtApp.$i18n.t('calendar_event_people_num', { branchName: order.value.branch_name, custNum: order.value.product?.qty })
        : nuxtApp.$i18n.t('calendar_event_people', { branchName: order.value.branch_name })
    ),
    description: computed(() => nuxtApp.$i18n.t('calendar_event_desc', { nameWithGender: nameTitle.value, productName: order.value.product.name })),
    address: `${order.value.area}${order.value.address}`,
    startAt: startTime.format('YYYYMMDDTHHmmss'),
    endAt: startTime.add(order.value.duration, 'm').format('YYYYMMDDTHHmmss'),
    link: location.value.href || '',
  })

  const appleCalendarString = computed(() =>
    [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'BEGIN:VEVENT',
      `DTSTART:${googleCalendarPayload.startAt}`,
      `DTSTAMP:${nuxtApp.$dayjs().format('YYYYMMDDTHHmmss')}`,
      `DTEND:${googleCalendarPayload.endAt}`,
      'STATUS:CONFIRMED',
      `SUMMARY:${googleCalendarPayload.summary}`,
      `LOCATION:${googleCalendarPayload.address}`,
      `DESCRIPTION:${googleCalendarPayload.description}`,
      `URL:${googleCalendarPayload.link}`,
      `BEGIN:VALARM`,
      `TRIGGER:-P1D`,
      `ACTION:DISPLAY`,
      `END:VALARM`,
      'END:VEVENT',
      'END:VCALENDAR',
    ].join('\r\n')
  )

  const googleCalendarLink = computed(() => {
    const searchParams = new URLSearchParams()
    searchParams.append('action', 'TEMPLATE')
    searchParams.append('text', googleCalendarPayload.summary)
    searchParams.append('dates', `${googleCalendarPayload.startAt}/${googleCalendarPayload.endAt}`)
    searchParams.append('location', googleCalendarPayload.address)
    searchParams.append('details', `${googleCalendarPayload.description} ${googleCalendarPayload.link}`)

    return `https://www.google.com/calendar/render?${searchParams.toString()}`
  })

  function downloadAppleCalendar() {
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(new Blob([appleCalendarString.value], { type: 'text/calendar' }))
    link.download = 'reservation.ics'
    link.click()
  }

  function downloadGoogleCalendar() {
    window.open(googleCalendarLink.value, '_blank')
  }

  return {
    downloadAppleCalendar,
    downloadGoogleCalendar,
  }
}

export function useOrderCalendarTitle(order = ref({})) {
  const remarks = ref(order.value.remark || [])
  // name remark id is 1 ( use id to get specific field )
  const nameTitle = computed(() => remarks.value.find(r => +r.id === 1)?.content || '')

  return {
    nameTitle,
  }
}
